import React from 'react';
import cx from './cx';

function FormControl({
  id,
  label,
  as = 'input',
  iconLeft,
  iconRight,
  iconRightInteractive = false,
  status = 'default',
  disabled = false,
  hint,
  message,
  className,
  inputClassName,
  'aria-invalid': ariaInvalid,
  'aria-describedby': ariaDescribedBy,
  ...props
}) {
  const Component = as;
  const hintId = hint && id ? `${id}-hint` : undefined;
  const messageId = message && id ? `${id}-message` : undefined;
  const describedBy = [ariaDescribedBy, hintId, messageId].filter(Boolean).join(' ') || undefined;
  const invalid = ariaInvalid !== undefined ? ariaInvalid : (status === 'error' ? true : undefined);
  const fieldClassName = cx(
    'rg-field',
    iconLeft && 'rg-field--icon-left',
    iconRight && 'rg-field--icon-right',
    status === 'error' && 'rg-field--error',
    status === 'valid' && 'rg-field--valid',
    disabled && 'rg-field--disabled',
    className
  );

  const controlClassName = cx(
    as === 'select' && 'rg-select',
    as === 'textarea' && 'rg-textarea',
    as !== 'select' && as !== 'textarea' && 'rg-input',
    'rg-focusable',
    inputClassName
  );

  return (
    <div className={fieldClassName}>
      {label && (
        <label htmlFor={id} className="rg-field__label">
          {label}
        </label>
      )}
      <div className="rg-field__control-wrap">
        {iconLeft && <span className="rg-field__icon rg-field__icon--left">{iconLeft}</span>}
        <Component
          id={id}
          className={controlClassName}
          disabled={disabled}
          aria-invalid={invalid}
          aria-describedby={describedBy}
          {...props}
        />
        {iconRight && (
          <span
            className={cx(
              'rg-field__icon',
              'rg-field__icon--right',
              iconRightInteractive && 'rg-field__icon--interactive'
            )}
          >
            {iconRight}
          </span>
        )}
      </div>
      {hint && <span id={hintId} className="rg-field__hint">{hint}</span>}
      {message && (
        <span
          id={messageId}
          className={cx('rg-field__message', status === 'error' && 'rg-field__message--error', status === 'valid' && 'rg-field__message--valid')}
        >
          {message}
        </span>
      )}
    </div>
  );
}

export default FormControl;
